export default {
  methods: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().replace(/_/g, ' ')
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    stringToArray: function (str) {
      var self = this
      var string = String(str)
      return string.split(',')
    },
    formatContributors: function (session) {
      var self = this
      if (session.contributors == null) return false
      var contributorArray = session.contributors.split(',')
      let contributors = contributorArray.map(function (value, index, array) {
        var formattedContributor = value.split('~')
        return {
          'avatar': formattedContributor[0],
          'name': formattedContributor[1],
          'role': formattedContributor[2]
        }
      })
      return contributors
    },
    splitArray: function (array) {
      var self = this
      if (array == null) return false
      return array.split(',')
    },
    formatStatus: function (status) {
      var self = this
      let result = self.statusFilters.find(filter => parseInt(filter.key) === status)
      return result.name.toLowerCase()
    },
    mapHeaderIcon (header) {
      switch (header) {
        case 'text':
          return 'fal fa-font'
          break
        case 'textarea':
          return 'fal fa-align-left'
          break
        case 'dropdown':
          return 'fal fa-caret-down'
          break
        case 'metric':
          return 'fal fa-tachometer'
          break
        case 'dropdown_multiple':
          return 'fal fa-check-square'
          break
      }
    },
    formatPreview (url) {
      if (url == null || url == '') {
        return 'http://www.theemailcompany.com/wp-content/uploads/2016/02/no-image-placeholder-big-300x200.jpg'
      }

      // url = url.replace('.jpg', '.webp')
      // url = url.replace('.png', '.webp')

      return url
    }
  }
}
